import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import ptBR from '../../messages/pt-BR.json'
import en from '../../messages/en.json'
import es from '../../messages/es.json'

const LOCALE_COOKIE = 'NEXT_LOCALE'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'pt-BR': { translation: ptBR },
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: 'pt-BR',
    supportedLngs: ['pt-BR', 'en', 'es'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['cookie', 'localStorage', 'navigator'],
      caches: ['cookie', 'localStorage'],
      lookupCookie: LOCALE_COOKIE,
    },
  })

export default i18n

export const locales = ['pt-BR', 'en', 'es'] as const
export const defaultLocale = 'pt-BR' as const
export type Locale = (typeof locales)[number]

export const localeNames: Record<Locale, string> = {
  'pt-BR': 'Português',
  en: 'English',
  es: 'Español',
}

export const changeLanguage = (locale: Locale) => {
  i18n.changeLanguage(locale)
  document.cookie = `${LOCALE_COOKIE}=${locale};path=/;max-age=31536000`
}
